import React from "react";
import { Tabs, Tab, Box, styled } from "@mui/material";

const CustomTabs = styled(Tabs)(() => ({
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabs-flexContainer": {
    gap: "8px",
  },
}));

const CustomTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 500,
  minHeight: "44px",
  padding: "8px 20px",
  borderRadius: "22px",
  backgroundColor: "white",
  color: theme.palette.grey[600],
  border: "1px solid transparent",
  "&.Mui-selected": {
    backgroundColor: `${theme.palette.primary.main}10`,
    color: `${theme.palette.primary.main}CC`,
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    boxShadow: `0 2px 12px 0 ${theme.palette.primary.main}33`,
  },
  "&:hover:not(.Mui-selected)": {
    backgroundColor: `${theme.palette.grey[50]}`,
  },
}));

const PreChartingTabs = ({ tabs, value, setValue }) => {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }} ml={2}>
      <CustomTabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="patient tabs"
      >
        {tabs.map((tab) => (
          <CustomTab key={tab.key} label={tab.label} value={tab.key} />
        ))}
      </CustomTabs>
    </Box>
  );
};

export default PreChartingTabs;
